/**
 * 值来源参考旧文件定义：common/utils/channel.js
 */

/** 渠道 */
export enum TrafficType {
  MSDK = 1,
  DSP = 2,
  Facebook = 3,
  GoogleAds = 4,
  Unity = 5,
  Vungle = 6,
  Applovin = 7,
  CSJ = 8,
  OceanEngine = 9,
  IronSource = 10,
  TencentAds = 11,
  Baidu = 12,
  Kuaishou = 13,
  AppStore = 14,
  WifiMasterKey = 15,
  FanPass = 16,
  Wechat = 17,
  ZuiYou = 18,
  TikTok = 19,
  Snapchat = 20,
  Mintegral = 21,
  Adcolony = 22,
  Tapjoy = 23,
  Chartboost = 24,
  Pangle = 25,
  MyTarget = 26,
  Liftoff = 27,
  Kwai = 28,
  AMS = 29,
  IMobile = 30,
  Moloco = 31,
  BIGO = 32,
  Smadex = 33,
  Other = 99, // 使用 99 的原因：不影响之后新增渠道
}
